import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Dashboard({ onLogout }) {
  const [forms, setForms] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  // Track screen width
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch forms
  useEffect(() => {
    fetch("https://api.pdf.tajgateways.com/api-v1/users/get-pdfs")
      .then((res) => res.json())
      .then((result) => {
        if (result.code === 200) {
          setForms(result.data);
        }
      })
      .catch((err) => console.error("Error fetching forms:", err));
  }, []);

  const isMobile = windowWidth < 600;
  const isTablet = windowWidth >= 600 && windowWidth < 992;

  return (
    <div
      style={{
        ...styles.container,
        padding: isMobile ? "20px" : "40px",
      }}
    >
      {/* Header */}
      <div
        style={{
          ...styles.header,
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          gap: isMobile ? "10px" : "0",
        }}
      >
        <h2
          style={{
            ...styles.title,
            fontSize: isMobile ? "20px" : "26px",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          Welcome {role === "admin" ? "Admin" : "User"} !!!
        </h2>
        <div style={styles.buttonGroup}>
          <button style={styles.logoutBtn} onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>

      {/* Forms buttons */}
      <div
        style={{
          ...styles.cardContainer,
          flexDirection: isMobile ? "column" : isTablet ? "row" : "row",
          flexWrap: isTablet ? "wrap" : "nowrap",
          gap: isMobile ? "15px" : "20px",
        }}
      >
        <button style={styles.cardBtn} onClick={() => navigate("/one-way")}>
          ✈️ One Way Ticket
        </button>
        <button style={styles.cardBtn} onClick={() => navigate("/round-trip")}>
          🔄 Round Trip Ticket
        </button>
        <button style={styles.cardBtn} onClick={() => navigate("/hotel-invoice")}>
          🏨 Hotel Invoice
        </button>
        <button style={styles.cardBtn} onClick={() => navigate("/itinerary")}>
          🗺️ Itinerary
        </button>
        <button style={styles.cardBtn} onClick={() => navigate("/hotel")}>
          🏨 Hotels
        </button>
        <button style={styles.cardBtn} onClick={() => navigate("/locations")}>
          Locations
        </button>

        {role === "admin" && (
          <button style={styles.cardBtn} onClick={() => navigate("/users")}>
            👤 Users
          </button>
        )}
      </div>

      {/* Table Section */}
      <div style={styles.tableSection}>
        <h3
          style={{
            ...styles.subtitle,
            fontSize: isMobile ? "18px" : "20px",
          }}
        >
          📑 Submitted Forms
        </h3>

        {forms.length === 0 ? (
          <p style={styles.noData}>No forms submitted yet.</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                ...styles.table,
                fontSize: isMobile ? "12px" : "14px",
                minWidth: "600px",
              }}
            >
            <thead>
              <tr>
                <th style={styles.tableHead}>Form Type</th>
                <th style={styles.tableHead}>Name</th>
                <th style={styles.tableHead}>Date</th>
                <th style={styles.tableHead}>Price (INR)</th>
                <th style={styles.tableHead}>Download</th>
              </tr>
            </thead>

            <tbody>
              {forms.map((form, index) => (
                <tr
                  key={form._id}
                  style={index % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd}
                >
                  <td>{form.type}</td>
                  <td>{form.name || "-"}</td>
                  <td>
                    {form.date ||
                      form.departureDate ||
                      form.checkin ||
                      "-"}
                  </td>
                  <td>
                    {form.price
                      ? Number(form.price).toLocaleString("en-IN", {
                        style: "currency",
                        currency: "INR",
                      })
                      : "-"}
                  </td>
                  <td>
                    {form.fileName ? (
                      <a
                        href={`https://api.pdf.tajgateways.com/download?fileName=${encodeURIComponent(
                          form.fileName
                        )}&name=${encodeURIComponent(form.name)}`}
                        download={`${form.name}-${form.fileName}.pdf`}
                      >
                        <button style={styles.downloadBtn}>⬇️ Download</button>
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          </div>
        )}
    </div>
    </div >
  );
}

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    background: "#f4f6f9",
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "30px",
  },
  title: {
    color: "#2c3e50",
    fontWeight: "600",
  },
  logoutBtn: {
    background: "#2980b9",
    border: "none",
    padding: "10px 18px",
    color: "#fff",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
  },
  cardContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    marginBottom: "40px",
  },
  cardBtn: {
    padding: "18px 22px",
    background: "#3498db",
    color: "#fff",
    fontSize: "15px",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    minWidth: "160px",
    transition: "0.3s",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
  subtitle: {
    color: "#34495e",
    marginBottom: "15px",
  },
  noData: {
    color: "#7f8c8d",
  },
  tableSection: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHead: {
    textAlign: "left",
    padding: "8px",
  },
  tableRowEven: {
    background: "#f9f9f9",
  },
  tableRowOdd: {
    background: "#ffffff",
  },
  downloadBtn: {
    padding: "8px 14px",
    background: "#27ae60",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
  },
};

export default Dashboard;
